module.exports = __webpack_public_path__ + "img/photo-0098.00ea7ced.jpg";